import axios from "axios";
import { Dropdown } from "flowbite-react";
import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

const ListData = () => {
  let navigate = useNavigate();

  const { state, handleFunction } = useContext(GlobalContext);

  const {
    data,
    setData,
    fetchStatus,
    setFetchStatus,
    currentId,
    setCurrentId,
    search,
    setSearch,
    filter,
    setFilter,
  } = state;

  const {
    handleEdit,
    handleDetail,
    handleDelete,
    handleText,
    handleChangeSearch,
    handleChangeFilter,
  } = handleFunction;

  useEffect(() => {
    if (fetchStatus === true) {
      axios
        .get("https://dev-example.sanbercloud.com/api/job-vacancy")
        .then((res) => {
          let data = res.data.data;
          // console.log(data);
          setData([...data]);
        })
        .catch((err) => {
          console.log(err);
        });
      setFetchStatus(false);
    }
  }, [fetchStatus]);

  const handleFilter = (event) => {
    event.preventDefault();
    console.log(filter);

    axios
      .get("https://dev-example.sanbercloud.com/api/job-vacancy")
      .then((res) => {
        let data = res.data.data;
        console.log(data);
        let filterData = data.filter((res) => {
          return (
            res.job_type === filter.job_type ||
            res.job_tenure === filter.job_tenure ||
            res.company_city === filter.company_city
          );
        });
        console.log(filterData);
        setData([...filterData]);
      })
      .catch((err) => {
        console.log(err);
      });
    setFetchStatus(false);
  };

  const handleSearch = (event) => {
    event.preventDefault();

    console.log(search);

    axios
      .get("https://dev-example.sanbercloud.com/api/job-vacancy")
      .then((res) => {
        let data = res.data.data;
        console.log(data);
        let searchData = data.filter((res) => {
          return Object.values(res)
            .join("")
            .toLowerCase()
            .includes(search.toLowerCase());
        });
        console.log(searchData);
        setData([...searchData]);
      })
      .catch((err) => {
        console.log(err);
      });
    setFetchStatus(false);
  };

  return (
    <React.Fragment>
      <div className="h-screen overflow-auto">
        <div className="border-black border-solid border-2 flex justify-evenly w-3/4 items-center pb-4">
          <form onSubmit={handleFilter} className=" p-4">
            <div className="w-3/4 m-6">
              <div>
                <label
                  htmlFor="company_city"
                  className="block my-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Domisili
                </label>
                <input
                  onChange={handleChangeFilter}
                  value={filter.company_city}
                  type="text"
                  id="company_city"
                  name="company_city"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              <div>
                <label
                  htmlFor="job_tenure"
                  className="block my-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Jenis Kontrak Kerja
                </label>
                <input
                  onChange={handleChangeFilter}
                  value={filter.job_tenure}
                  type="text"
                  id="job_tenure"
                  name="job_tenure"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              <div>
                <label
                  htmlFor="job_type"
                  className="block my-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Tipe Kerja
                </label>
                <input
                  onChange={handleChangeFilter}
                  value={filter.job_type}
                  type="text"
                  id="job_type"
                  name="job_type"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
            </div>
            <button
              type="submit"
              className="ml-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Filter
            </button>
          </form>
          <button
            onClick={() => setFetchStatus(true)}
            type="submit"
            className=" p-2 ml-6 text-sm font-medium text-white bg-red-500 rounded-lg border border-slate-200 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Reset Filter
            <span className="sr-only">Filter</span>
          </button>

          <label htmlFor="table-search" className="sr-only">
            Search
          </label>
          <form
            onSubmit={handleSearch}
            className="flex justify-center items-center"
          >
            <label htmlFor="simple-search" className="sr-only">
              Cari Disini...
            </label>
            <div className="relative ">
              <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 text-gray-500 dark:text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="simple-search"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-cyan-500 focus:border-cyan-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search"
                value={search}
                onChange={handleChangeSearch}
                required
              />
            </div>
            <button
              type="submit"
              className="p-2.5 ml-2 text-sm font-medium text-white bg-cyan-500 rounded-lg border border-slate-200 hover:bg-cyan-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <span className="sr-only">Search</span>
            </button>
          </form>
          <button
            onClick={() => setFetchStatus(true)}
            type="submit"
            className=" p-2.5 text-sm font-medium text-white bg-red-500 rounded-lg border border-slate-200 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Reset Pencarian
            <span className="sr-only">Search</span>
          </button>
        </div>
        <h1 className="uppercase font-bold text-red-500">
          Terdapat scroll pada table untuk melihat data yang terpotong
        </h1>
        <div className=" relative max-h-screen w-3/4 overflow-scroll sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  Nama Pekerjaan
                </th>
                <th scope="col" className="py-3 px-6">
                  Deskripsi
                </th>
                <th scope="col" className="py-3 px-6">
                  Kualifikasi
                </th>
                <th scope="col" className="py-3 px-6">
                  Tipe
                </th>
                <th scope="col" className="py-3 px-6">
                  Kontrak Kerja
                </th>
                <th scope="col" className="py-3 px-6">
                  Status
                </th>
                <th scope="col" className="py-3 px-6">
                  Nama Perusahaan
                </th>
                <th scope="col" className="py-3 px-6">
                  Gambar Logo Perusahaan
                </th>
                <th scope="col" className="py-3 px-6">
                  Domisili
                </th>
                <th scope="col" className="py-3 px-6">
                  Gaji Minimal
                </th>
                <th scope="col" className="py-3 px-6">
                  Gaji Maksimal
                </th>
                <th scope="col" className="py-3 px-6">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {data !== null &&
                data.map((res) => {
                  return (
                    <tr
                      key={res.id}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <th
                        scope="row"
                        className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        {res.title}
                      </th>
                      <td className="py-4 px-6">
                        {handleText(res.job_description)}
                      </td>
                      <td className="py-4 px-6">
                        {handleText(res.job_qualification)}
                      </td>
                      <td className="py-4 px-6">{res.job_type}</td>
                      <td className="py-4 px-6">{res.job_tenure}</td>
                      <td className="py-4 px-6">{res.job_status}</td>
                      <td className="py-4 px-6">{res.company_name}</td>
                      <td className="py-4 px-6">
                        <img src={res.company_image_url} alt="company" />
                      </td>
                      <td className="py-4 px-6">{res.company_city}</td>
                      <td className="py-4 px-6">{res.salary_min}</td>
                      <td className="py-4 px-6">{res.salary_max}</td>
                      <td className="py-4 px-6 flex">
                        <button
                          value={res.id}
                          onClick={handleEdit}
                          type="button"
                          className="focus:outline-none text-white bg-yellow-300 hover:bg-yellow-400 focus:ring-4 focus:ring-transparent font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:focus:ring-yellow-900"
                        >
                          Edit
                        </button>
                        <button
                          value={res.id}
                          onClick={handleDelete}
                          type="button"
                          className="focus:outline-none text-white bg-red-500 hover:bg-red-800 focus:ring-4 focus:ring-transparent font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
